import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import NoneIcon from '../../../assets/icons/none-icon.png';
import Container from '../../../components/Container/Container';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import styles from './JockeyItem.module.scss';
const JockeyItem = ({ data, savedUserSelection, handleUserSelection, canNavigate }) => {
    const darkMode = useSelector((state) => state.settings.darkMode);
    const emptyItem = {
        displayName: 'None',
        asset: {
            assetName: ''
        },
        image: {
            src: NoneIcon
        }
    };
    const jockeyData = useMemo(() => [emptyItem, ...data], [data]);
    const JockeyItem = ({ displayName, image, asset }) => {
        const imageSrc = image.src.replace('ipfs://', 'https://ipfs.io/ipfs/');
        return (_jsxs("div", Object.assign({ "data-testid": `jockeyItem-${asset.assetName}`, onClick: () => canNavigate && handleUserSelection(asset.assetName), className: cn(styles.wrapper, darkMode && styles.isDarkMode, 'd-flex align-items-end', asset.assetName === savedUserSelection && styles.wrapper_selected) }, { children: [_jsx("img", { src: imageSrc, alt: "", className: styles.image }), _jsx(Paragraph, { size: 1, fontFamily: 'urbanist', title: displayName })] }), asset.assetName));
    };
    return (_jsx("div", Object.assign({ className: cn(styles.element, 'd-flex', !canNavigate && styles.disabled) }, { children: _jsx(Container, Object.assign({ className: 'd-flex' }, { children: jockeyData.map(JockeyItem) })) })));
};
export default JockeyItem;
